import { Link } from 'react-router-dom';
import ArticleLayout from '@/components/ArticleLayout';

const couponGuides = [
  { title: 'CSSBuy Coupon Guide', to: '/coupon/cssbuy-coupon', desc: 'Finding, verifying, and using discount codes and promotions.' },
];

export default function CouponPage() {
  return (
    <ArticleLayout
      title="CSSBuy Coupons"
      description="Guides to finding and verifying CSSBuy coupons, discount codes, and promotional offers."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Coupon', to: '/coupon' },
      ]}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {couponGuides.map((guide) => (
          <Link
            key={guide.to}
            to={guide.to}
            className="group p-5 bg-background-50 border border-background-200 rounded-xl hover:bg-primary-50 hover:border-primary-200 transition-all"
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 group-hover:bg-primary-200 flex items-center justify-center shrink-0 transition-colors">
                <i className="ri-coupon-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 mb-1">
                  {guide.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{guide.desc}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </ArticleLayout>
  );
}